import { useEffect, useState, useMemo, useCallback } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton, Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { postRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import { handleErrorMessages } from 'src/pages/components/errorhanling-formating';
import { MultiFilePreview, Upload } from 'src/components/upload';

export const ProductFeaturesImageModal = ({ open, onClose, reload, currentItem, closeform, }) => {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);
    const [ files, setFiles ] = useState([]);
    const [ isFileDeleted, setIsFileDeleted ] = useState(false);
    const [ filePreview, setFilePreview ] = useState([]);

    const NewDocumentSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        description: Yup.string().required('Description is required'),
        // file: Yup.array().min(1, 'Images is required'),

    });

    const defaultValues = useMemo(
        () => ({

            file: currentItem?.file || 'None',

        }),
        [ currentItem ]
    );
    useEffect(() => {
        console.log("🚀 ~ defaultValues------:", defaultValues)
        if (currentItem) {
            if (currentItem.file != null) {
                setFilePreview([ { ...currentItem.file, preview: currentItem.file.url } ]);
            } else {
                setFilePreview([]);
            }
        }
    }, [ defaultValues ]);

    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [ currentItem, reset, defaultValues ]);

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();

        if (isFileDeleted) {
            formData.append('is_file_deleted', true);
        }
        if (files.length > 0) {
            formData.append('file', files[ 0 ]);
        }
        try {
            const response = await postRequest(
                currentItem?.id
                    ? `${endpoints.accounting.documents.post_request}/${currentItem.id}?_method=PUT`
                    : endpoints.accounting.documents.post_request,
                formData,
                true
            );

            if (response.metadata?.success) {
                reset();
                onClose();
                reload();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });

    const handleDrop = useCallback(
        (acceptedFiles) => {
            const newFiles = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                }));
            setFiles([ ...newFiles ]);
        },
        [ files ]
    );
    const handleClose = () => {
        console.log("close clicked----");
        setIsFileDeleted(false);
        onClose();
    };
    const handleRemoveFile = (inputFile) => {
        setIsFileDeleted(true);
        setFiles([]);
        setFilePreview([]);
    };
    return (
        <Dialog
            open={ open }
            onClose={ (event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            } }
            fullWidth
            maxWidth="md"
            sx={ {
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            } }
            transitionDuration={ {
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            } }
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                    <span
                        className='cardColor'
                        style={ {
                            padding: '7px', marginLeft: '-25px', fontWeight: '700',
                            backgroundColor: "#F4F6F8",
                            color: '#637381'
                        } }
                    >
                        &nbsp;&nbsp; Upload Images &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={ onClose }>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>

                    <Box
                        mt={ 4 }
                        rowGap={ 3 }
                        display="grid"
                        gridTemplateColumns={ {
                            xs: 'repeat(1, 1fr)',
                        } }
                    >
                        <Upload onDrop={ handleDrop } onRemove={ handleRemoveFile } name='file' />
                    </Box>
                    <Box sx={ { my: 3 } }>
                        <MultiFilePreview
                            files={ files?.length > 0 ? files : filePreview }
                            onRemove={ handleRemoveFile }
                            setFileDeleted={ setIsFileDeleted }
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={ onClose }>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        className='dark-button'
                        loading={ isSubmitting }
                    >
                        Upload
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog >
    );
};